import NotVerifiedEmailHeader from './NotVerifiedEmailHeader'

export default NotVerifiedEmailHeader
